export default "__VITE_ASSET__BbbVs7OM__"